var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import lodash from 'lodash';
import { Throttle } from 'lodash-decorators';
import { action, observable } from 'mobx';
import { timer } from 'rxjs';
import { EnumAPI } from '../../apis';
import { numFormat } from '../../helpers';
import { BaseModel } from '../../libraries';
import { AjaxBasics } from './../../libraries';
import { WebSocket } from './socket';
import { createUserModel } from './userInfo';
export class LikeController {
    constructor() {
        this.Model = new BaseModel({ type: 'object' });
        //点赞自增
        this.tempLikes = 0;
        //已发送的点赞数
        this.sendLikes = 0;
        //用户数据
        this.UserInfo = createUserModel();
    }
    //websocket暂不使用 改用轮询
    async onPolling() {
        await this.onGetLikeNum();
        timer(10000).subscribe(() => {
            this.onPolling();
        });
    }
    async onGetLikeNum() {
        try {
            const res = await AjaxBasics.request(lodash.assign(EnumAPI.live_kudos_search, {
                body: {
                    liveId: this.UserInfo.liveId,
                },
            }));
            const likes = lodash.get(res, 'likes', 0);
            if (likes > this.likes) {
                this.onSetState('sendLikes', 0);
                this.Model.merge({ likeInfo: res });
            }
        }
        catch (error) { }
    }
    async onSendLikeNum() {
        try {
            await AjaxBasics.request(lodash.assign(EnumAPI.live_kudos_trigger, {
                body: {
                    likes: this.tempLikes,
                    userId: this.UserInfo.userCode,
                    liveId: this.UserInfo.liveId,
                },
            }));
            const tempSendLikes = lodash.add(this.sendLikes, this.tempLikes);
            this.onSetState('sendLikes', tempSendLikes);
            this.onSetState('tempLikes', 0);
        }
        catch (error) { }
    }
    createWebsocket() {
        this.webSocket = new WebSocket('/livews/subscribe', 'KUDOS');
        this.webSocket.observable.subscribe((msg) => this.onSocketReceived(msg), //每当有来自服务器的消息时调用。
        (err) => this.onSocketError(err), // 调用如果在任何点WebSocket API信号某种错误
        () => this.onSocketComplete());
    }
    connectWebsocket() {
        if (this.connectTimer) {
            this.connectTimer.unsubscribe();
        }
        this.connectTimer = timer(5000).subscribe(() => {
            this.createWebsocket();
        });
    }
    get likeInfo() {
        return lodash.get(this.Model.value, 'likeInfo');
    }
    get likes() {
        const likes = lodash.get(this.likeInfo, 'likes', 0);
        const tempLikes = lodash.add(this.tempLikes, this.sendLikes);
        return lodash.add(parseInt(likes), tempLikes);
    }
    get likesFormat() {
        return numFormat(this.likes);
    }
    onSetState(name, num) {
        this[name] = num;
    }
    onAddLikes() {
        this.onSetState('tempLikes', ++this.tempLikes);
    }
    onSocketSend() {
        this.webSocket.onSend({
            type: 'KUDOS',
            data: {
                likes: this.tempLikes,
                userId: this.UserInfo.userCode,
                liveId: this.UserInfo.liveId,
                sourceCode: 'b415e203-4e8d-11ed-995c-0242ac110002',
            },
        });
        const tempSendLikes = lodash.add(this.sendLikes, this.tempLikes);
        this.onSetState('sendLikes', tempSendLikes);
        this.onSetState('tempLikes', 0);
    }
    onSocketReceived(msg) {
        const likes = lodash.get(msg.data, 'likes', 0);
        if (likes > this.likes) {
            this.onSetState('sendLikes', 0);
            this.Model.merge({ likeInfo: msg.data });
        }
    }
    onSocketComplete() {
        this.connectWebsocket();
    }
    onSocketError(err) {
        console.log(err, ' onSocket err');
    }
}
__decorate([
    observable
], LikeController.prototype, "tempLikes", void 0);
__decorate([
    observable
], LikeController.prototype, "sendLikes", void 0);
__decorate([
    Throttle(3000)
], LikeController.prototype, "onSendLikeNum", null);
__decorate([
    action.bound
], LikeController.prototype, "onSetState", null);
__decorate([
    action.bound
], LikeController.prototype, "onAddLikes", null);
__decorate([
    Throttle(3000)
], LikeController.prototype, "onSocketSend", null);
